var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPageLast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_page_front_10_32",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_5",
    "data-name": "\\uC0AC\\uAC01\\uD615 5",
    width: 32,
    height: 32,
    fill: "#999",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(11.4 11.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_173",
    "data-name": "\\uADF8\\uB8F9 173",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_356",
    "data-name": "\\uD328\\uC2A4 356",
    d: "M348.143,165.575a.6.6,0,0,0,.424-.176l4-4a.6.6,0,0,0,0-.849l-4-4a.6.6,0,0,0-.847.849l3.575,3.576-3.575,3.575a.6.6,0,0,0,.423,1.025Z",
    transform: "translate(-347.544 -156.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_357",
    "data-name": "\\uD328\\uC2A4 357",
    d: "M344.143,165.575a.6.6,0,0,0,.424-.176l4-4a.6.6,0,0,0,0-.849l-4-4a.6.6,0,1,0-.847.849l3.575,3.576-3.575,3.575a.6.6,0,0,0,.423,1.025Z",
    transform: "translate(-339.544 -156.374)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPageLast);
export default __webpack_public_path__ + "static/media/icon_page_last.9367ef1a0910f6ad780915f5e1c65611.svg";
export { ForwardRef as ReactComponent };